<template>
	<div class="user-icon" :class="{ 'user-letter': showLetter }" :style="wrapperStyles">
		<div v-if="src" :style="logoBackgroundSrc" class="logo-icon" />
		<div v-else>
			<div v-if="showLetter" class="user-letter text-white font-uppercase">
				{{ userLetter }}
			</div>
			<SVGIcon v-else icon-name="user-logo" :width="sizeStyles.width" :height="sizeStyles.height" fill="transparent" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SVGIcon } from '~/components/interface'

export default {
	name: 'UserIcon',
	components: { SVGIcon },
	props: {
		src: {
			type: String,
			default: null
		},
		size: {
			type: String,
			default: 'small'
		},
		showLetter: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters({ user: 'user/user' }),

		userLetter () {
			return this.user.name.slice(0, 1)
		},
		wrapperStyles () {
			switch (this.size) {
					case 'large':
						return { width: `${this.sizeStyles.width}px`, height: `${this.sizeStyles.height}px`, 'font-size': '48px' }
					case 'small':
					default:
						return { width: `${this.sizeStyles.width}px`, height: `${this.sizeStyles.height}px`, 'font-size': '15px' }
			}
		},
		sizeStyles () {
			switch (this.size) {
					case 'large':
						return { width: 68, height: 68 }
					case 'small':
					default:
						return { width: 30, height: 30 }
			}
		},
		logoBackgroundSrc () {
			return { backgroundImage: `url(${this.src})` }
		}
	}
}
</script>

<style lang="scss">
	@import "assets/scss/base/basics";

	.user-icon {
		cursor: pointer;
		display: inline-block;
		border-radius: 50px;
		background-color: rgba(#1A1A1A, 0.2);
		&.user-letter {
			border: solid 4px #8ad2e9;
			background-color: #1a1a1a;
		}
	}

	.user-letter {
		line-height: 1.4;
		font-weight: 300;
		text-align: center;
		user-select: none;
	}
</style>
